import clsx from 'clsx';

import { Section } from '../section/index.ts';

import CheckCircleIcon from './check-circle-icon.svg?react';

// oxlint-disable-next-line react/only-export-components
const Root = (props: { children: React.ReactNode; className?: string }) => {
  return (
    <Section.Container
      gutter={false}
      className={clsx('bg-white pb-8 text-v1-background-200', props.className)}
    >
      <Section.Content className="flex flex-col rounded-b-xl bg-[#EFF7FF] sm:rounded-xl md:flex-row-reverse lg:rounded-2xl">
        {props.children}
      </Section.Content>
    </Section.Container>
  );
};

// oxlint-disable-next-line react/only-export-components
const ImageContainer = (props: { children: React.ReactNode; className?: string }) => {
  return (
    <div
      className={clsx(
        'relative isolate mx-auto grid h-78 w-full flex-2 grid-cols-1 grid-rows-1 items-end justify-items-center overflow-hidden pt-4 md:h-auto md:rounded-xl lg:rounded-2xl',
        props.className,
      )}
      style={{
        background:
          'radial-gradient(98.73% 52.1% at 47.33% 51.23%, rgba(255, 255, 255, 0.49) 0%, rgba(255, 255, 255, 0.00) 97.5%), #18A0FB',
      }}
    >
      <div className="grid size-full max-h-full max-w-full">{props.children}</div>
    </div>
  );
};

// oxlint-disable-next-line react/only-export-components
const Image = (props: {
  src: string;
  width: number;
  height: number;
  alt: string;
  align?: 'center' | 'bottom';
}) => {
  return (
    <img
      src={props.src}
      alt={props.alt}
      width={props.width}
      height={props.height}
      className={clsx(
        'w-full object-contain',
        props.align === 'center' ? 'object-bg-center m-auto' : 'mt-auto object-bottom',
      )}
    />
  );
};

// oxlint-disable-next-line react/only-export-components
const Content = (props: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-3 flex-col items-center px-6 py-8 pb-10 lg:py-12">
      <div className="flex max-w-md flex-col items-center">{props.children}</div>
    </div>
  );
};

// oxlint-disable-next-line react/only-export-components
const Title = (props: { children: React.ReactNode }) => {
  return <h1 className="mb-4 text-center typography-v1-h1 lg:mb-6">{props.children}</h1>;
};

// oxlint-disable-next-line react/only-export-components
const List = (props: { children: React.ReactNode; className?: string }) => {
  return (
    <ul
      className={clsx(
        'mb-6 flex max-w-xs flex-col gap-3 typography-v1-body3 md:mb-8 lg:mb-10 lg:gap-4',
        props.className,
      )}
    >
      {props.children}
    </ul>
  );
};

// oxlint-disable-next-line react/only-export-components
const ListItem = (props: { children: React.ReactNode }) => {
  return (
    <li className="flex items-center gap-2">
      <CheckCircleIcon className="shrink-0" />
      {props.children}
    </li>
  );
};

export const SplitHeroSection = {
  Root,
  ImageContainer,
  Image,
  Content,
  Title,
  List,
  ListItem,
};
